export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";